import WebService from "../../../Services/WebService";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import {
  DocumentDetailsInterface,
  RegistrationIds,
} from "../../../assets/interface/primeSharkWebsite_interface";

import Select from "react-dropdown-select";
import HelperService from "../../../Services/HelperService";
import ErrorComponent from "../../Common/ErrorComponent";
import CompoLoader from "../../ComponentLoader/CompoLoader";
import UploadDocument from "../UploadDocument/UploadDocuments";
import { getDocumentIfAvailable } from "../../../Services/CommonFunction";
import { DOCUMENT_TYPE } from "../../../assets/constants/constants";
import RequiredLabel from "../../Common/RequiredLabel/RequiredLabel";
import CommonScrollbar from "../../Common/ScrollBar/CommonScrollbar";
import { Button } from "react-bootstrap";

interface PropsData {
  impIds: RegistrationIds;
  handleNext: any;
  from?: any;
}

const proofOfBusinessTypes = [
  {
    label: "Business Registration",
    value: "BUSINESS_REGISTRATION_CERTIFICATE",
  },
  {
    label: "Tax Identification",
    value: "TAX_IDENTIFICATION_NUMBER_CERTIFICATE",
  },
  { label: "Business License", value: "BUSINESS_LICENSE" },
  { label: "Articles of Incorporation", value: "ARTICLES_OF_INCORPORATION" },
  {
    label: "Certificate of Good Standing",
    value: "CERTIFICATE_OF_GOOD_STANDING",
  },
  { label: "Operating Agreement (LLC)", value: "OPERATING_AGREEMENT_FOR_LLC" },
  { label: "Partnership Agreement", value: "PARTNERSHIP_AGREEMENT" },
  { label: "Bank Account Statement", value: "BANK_ACCOUNT_STATEMENT" },
  {
    label: "Utility Bill (Business Name)",
    value: "UTILITY_BILL_IN_BUSINESS_NAME",
  },
  {
    label: "VAT/GST Registration Certificate",
    value: "VAT_OR_GST_REGISTRATION_CERTIFICATE",
  },
  { label: "Trade License", value: "TRADE_LICENSE" },
  { label: "Insurance Certificate", value: "INSURANCE_CERTIFICATE" },
  {
    label: "Client Contracts or Invoices",
    value: "CONTRACTS_OR_INVOICES_FROM_CLIENTS",
  },
];

const DocumentsDetails_INVESTOR = ({ impIds, handleNext, from }: PropsData) => {
  const [documents, setDocuments] = useState<DocumentDetailsInterface[]>([]);
  const [fileLoaders, setFileLoaders] = useState<{ [key: string]: boolean }>(
    {},
  );

  const [selectedTypeOfProof, setSelectedTypeOfProof] = useState([
    { value: "", label: "Select" },
  ]);
  const [pitchDeck, setPitchDeck] = useState(0);
  const [loader, setLoader] = useState(false);

  useEffect(() => {
    if (impIds && impIds?.business_uuid) {
      handleGetDocumentDetails();
    }
  }, []);

  const handleGetDocumentDetails = () => {
    setLoader(true);
    WebService.getAPI({
      action: `get-business/investor/${impIds?.business_uuid}`,
      body: null,
      isShowError: true,
    })
      .then((res: any) => {
        if (res?.status === true) {
          setDocuments(res?.info?.documents);
          if (res?.info?.documents?.length > 0) {
            res?.info?.documents.forEach((docu: DocumentDetailsInterface) => {
              if (docu?.type === "PITCH_DECK") {
                setPitchDeck(1);
              }
              if (
                docu?.type !== "PITCH_DECK" &&
                docu?.type !== "BUSINESS_PHOTO"
              ) {
                setSelectedTypeOfProof([
                  {
                    value: docu?.type,
                    label: HelperService.removeUnderScore(docu.type),
                  },
                ]);
              } else {
                setSelectedTypeOfProof([{ value: "", label: "Select" }]);
              }
            });
          }
        }
      })
      .catch((error: any) => {
        return false;
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const uploadFile = (event: any) => {
    const selectedFiles = event.target.files;
    let maxSizeFile = false;
    Array.from(selectedFiles).map((file: any) => {
      if (file.size > 10 * 1024 * 1024) {
        maxSizeFile = true;
        toast.error("Maximum file size 10 mb");
        return;
      }
    });
    if (maxSizeFile) {
      return;
    }

    if (selectedFiles && selectedFiles.length > 0) {
      handleUploadFile(selectedFiles[0], event.target.name);

      event.target.value = null;
    }
  };

  async function handleUploadFile(file: any, type: string) {
    if (type === "") {
      toast.error("Please select type of document first");
      return;
    }
    let body = {
      type: type,
      is_pitch_deck: pitchDeck,
    };
    setFileLoaders((prev) => ({ ...prev, [type]: true }));
    await WebService.uploadAPI({
      action: `upload-document/investor/${impIds?.business_uuid}`,
      body: body,
      _file: file,
      key: "file",
    })
      .then((res: any) => {
        if (res?.status) {
          handleGetDocumentDetails();

          toast.success(res?.message);
        } else {
          toast.error(res?.message);
        }
      })
      .catch((error: any) => {
        toast.error(error?.response?.data?.message);
        return error;
      })
      .finally(() => {
        setFileLoaders((prev) => ({ ...prev, [type]: false }));
      });
  }
  const getDocumentTitle = (title: string) => {
    if (documents && documents?.length > 0) {
      let docTitle: DocumentDetailsInterface = {
        file_name: "",
        title: "",
        type: "",
        file_title: "",
      };
      documents.forEach((docu: DocumentDetailsInterface) => {
        if (docu?.type === title) {
          docTitle = docu;
        }
      });
      return docTitle;
    } else return null;
  };
  const handleContinue = () => {
    // if (documents?.length < 2) {
    //   setErrorFlag(true);
    //   return;
    // } else {
    //   setErrorFlag(false);
    handleNext();
    // }
  };
  return (
    <>
      <div className="login-form w-100  position-relative">
        {loader ? <CompoLoader /> : null}

        <div className="custom-title my-auto font-bold mb-2">Documents</div>
        <p className="font-14 mb-1">Please upload all the documents below.</p>
        <CommonScrollbar height={"65vh"}>
          <div className="me-3">
            <RequiredLabel isRequired={false}>Business Photo</RequiredLabel>
            <UploadDocument
              type={"BUSINESS_PHOTO"}
              fileLoaders={fileLoaders}
              uploadFile={uploadFile}
              document={getDocumentIfAvailable(
                DOCUMENT_TYPE.BUSINES_PHOTO,
                documents,
              )}
              infoCall={() => handleGetDocumentDetails()}
            />
            {/* <ErrorComponent
            title="Please upload business photo"
            flag={errorFlag}
            isArray={false}
            data={getDocumentTitle("BUSINESS_PHOTO")?.title ?? ""}
          /> */}

            <div className="mb-2">
              <RequiredLabel isRequired={false}>Proof of Business</RequiredLabel>
              <Select
                dropdownHeight="200px"
                className="multi-select"
                options={proofOfBusinessTypes}
                onChange={(values: any) => {
                  if (values.length > 0) {
                    setSelectedTypeOfProof(values);
                  }
                }}
                labelField="label"
                valueField="value"
                placeholder="Select"
                name="proof"
                values={selectedTypeOfProof}
              />
            </div>
            <UploadDocument
              type={selectedTypeOfProof[0]?.value}
              fileLoaders={fileLoaders}
              uploadFile={uploadFile}
              documentList={documents}
              infoCall={() => handleGetDocumentDetails()}
            />
            {/* {documents && documents?.length < 2 && (
            <ErrorComponent
              title="Please upload business proof"
              flag={errorFlag}
              isArray={false}
              data={""}
            />
          )} */}
            <div>
              <RequiredLabel isRequired={false}>
                Additional Supporting Docs Like Investment Portfolio, etc.
              </RequiredLabel>
              <UploadDocument
                type={DOCUMENT_TYPE?.ADDITIONAL_SUPPORTING_DOCUMENT}
                fileLoaders={fileLoaders}
                uploadFile={uploadFile}
                document={getDocumentIfAvailable(
                  DOCUMENT_TYPE.ADDITIONAL_SUPPORTING_DOCUMENT,
                  documents,
                )}
                infoCall={() => handleGetDocumentDetails()}
                accept=".pdf, .doc, .docx, .jpg, .jpeg, .png"
              />
            </div>

            <div className="mb-2 d-flex gap-2">
              <Button
                className={
                  from === "REVIEW" || from === "FROM_PROFILE_ANALYSIS"
                    ? "btn btn-primary w-100"
                    : "btn btn-primary w-50"
                }
                type="button"
                id="link_btn"
                onClick={handleContinue}
              >
                {from && from === "REVIEW" ? "Save" : "Continue"}
              </Button>
              {from !== "REVIEW" && from !== "FROM_PROFILE_ANALYSIS" && (
                <Button
                  className="btn btn-secondary w-50"
                  type="button"
                  id="skip_basic_details"
                  onClick={() => {
                    handleNext(true);
                  }}
                >
                  Skip
                </Button>
              )}
            </div>

          </div>
        </CommonScrollbar>
      </div>
    </>
  );
};
export default DocumentsDetails_INVESTOR;
